import React from "react";
import { formatDateTimeWithTz } from "../../../../../utils/formatDateTimeWithTz";
import { LogRenderContext } from "./LogRenderer";

const GetUpdatedOnBy = ({ updatedAt, updatedBy }) => {
  const { userTimeZone } = React.useContext(LogRenderContext);
  if (!updatedAt || !updatedBy) {
    return null; // Return null if no data is available
  }
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "25%",
        paddingBottom: "10px",
        paddingTop: "10px",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <div>Updated On</div>
        <div>{formatDateTimeWithTz(updatedAt, userTimeZone)}</div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <div>Updated By</div>
        <div style={{ fontSize: "1em" }}>{`${updatedBy.firstName} ${updatedBy.lastName}`}</div>
        <div style={{ fontSize: "0.8em", color: "#666" }}>{updatedBy.email?.toLowerCase()}</div>
      </div>
    </div>
  );
};
export default GetUpdatedOnBy;
